export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ink text-cloud-400 sticky bottom-0 w-full py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <a
          href="https://sfruby.com"
          target="_blank"
          rel="noreferrer"
          className="inline-block"
        >
          <span className="flex items-center gap-3">
            <img
              src="/logo8bit-mascot.png"
              alt=""
              width={392}
              height={448}
              className="px-pixelated h-12 w-auto"
              loading="lazy"
            />
            <span className="px-font text-sm text-white">SF Ruby</span>
          </span>
        </a>
        <div className="border-cloud-800 mt-8 flex flex-col items-center justify-between border-t pt-6 md:flex-row">
          <p className="text-cloud-400 text-sm">
            &copy; {currentYear} SF Ruby Startup Conference
          </p>
        </div>
      </div>
    </footer>
  );
}
